import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import TermsOfUseModal from '../src/components/modals/TermsOfUseModal';
import { colors } from '../src/styles/theme';

export default function TermsRoute() {
  const router = useRouter();

  const handleDismiss = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace('/');
    }
  };

  return (
    <View style={styles.container}>
      <TermsOfUseModal
        visible={true}
        onClose={handleDismiss}
        onBack={handleDismiss}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
});
